



































import { defineComponent, computed, ref, watch, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
export default defineComponent({
  props: {
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    teamName: {
      required: false,
      type: String,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const title = ref('');
    const tmpPath = ref('');
    const deleteDirectly = ref(true);
    const methods = {
      changeChecked() {
        deleteDirectly.value = !deleteDirectly.value;
      },
      async submit() {
        if (deleteDirectly.value) {
          context.emit('onSubmit', false, '');
        } else {
          context.emit('onSubmit', true, tmpPath.value);
        }
      },
    };
    watch(innerShow, (newVal, oldVal) => {
      if (newVal) {
        title.value = i18n_t('确定要删除“{slot1}”吗？', {
          slot1: props.teamName,
        });
        tmpPath.value = i18n_t('被删除的【{slot1}】团队文件', {
          slot1: props.teamName,
        });
      }
    });
    return {
      innerShow,
      title,
      tmpPath,
      deleteDirectly,
      ...methods,
    };
  },
});
